import BtSupervisionNote from '../pages/supervision-notes/BtSupervisionNote';
import ClientSupervisionNote from '../pages/supervision-notes/ClientSupervisionNote';
import ParentSupervisionNote from '../pages/supervision-notes/ParentSupervisionNote';
import GroupParentSupervisionNote from '../pages/supervision-notes/GroupParentSupervision';
import { AssessmentNote } from '../pages/supervision-notes/AssessmentNote';
import { Roles } from '../constants';

export const supervisionRoutes = [
  {
    path: '/supervisions/:id',
    type: 'redirect',
    oldPath: '/supervisions/',
    newPath: '/client-supervisions/',
    roles: [
      Roles.Bcba,
      Roles.AssistantAssessor,
      Roles.Prbt,
      Roles.Admin,
      Roles.ClientSuccessManager,
      Roles.Biller,
      Roles.InvoiceCoordinator,
      Roles.QaSpecialist,
      Roles.Vbt,
      Roles.LimitedAccessGuardian,
    ],
  },
  {
    path: '/client-supervisions/:id',
    type: 'private',
    elem: <ClientSupervisionNote />,
    roles: [
      Roles.Bcba,
      Roles.AssistantAssessor,
      Roles.Prbt,
      Roles.Admin,
      Roles.ClientSuccessManager,
      Roles.Biller,
      Roles.InvoiceCoordinator,
      Roles.QaSpecialist,
      Roles.Vbt,
      Roles.LimitedAccessGuardian,
    ],
  },
  {
    path: '/client-supervisions/new',
    type: 'private',
    elem: <ClientSupervisionNote />,
    roles: [Roles.Bcba],
  },
  {
    path: '/bt-supervisions/:id',
    type: 'private',
    elem: <BtSupervisionNote />,
    roles: [
      Roles.Bcba,
      Roles.AssistantAssessor,
      Roles.Admin,
      Roles.ClientSuccessManager,
      Roles.Biller,
      Roles.InvoiceCoordinator,
      Roles.QaSpecialist,
    ],
  },
  {
    path: '/parent-supervisions/:id',
    type: 'private',
    elem: <ParentSupervisionNote />,
    roles: [
      Roles.Bcba,
      Roles.AssistantAssessor,
      Roles.Admin,
      Roles.ClientSuccessManager,
      Roles.Biller,
      Roles.InvoiceCoordinator,
      Roles.QaSpecialist,
    ],
  },
  {
    path: '/assessment-note/:id',
    type: 'private',
    elem: <AssessmentNote />,
    roles: [
      Roles.Bcba,
      Roles.AssistantAssessor,
      Roles.Admin,
      Roles.ClientSuccessManager,
      Roles.Biller,
      Roles.InvoiceCoordinator,
    ],
  },
  {
    path: '/group-parent-training/:id',
    type: 'private',
    elem: <GroupParentSupervisionNote />,
    roles: [
      Roles.Bcba,
      Roles.Admin,
      Roles.ClientSuccessManager,
      Roles.Biller,
      Roles.InvoiceCoordinator,
    ],
  },
];
